import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useEventListener } from 'taboola-ultimate-ui';
import { authTokenManager } from '../../taboola-common-frontend-modules/authentication';

const TaApiContext = createContext();

export const TAApiProvider = ({ children, isMock = false }) => {
    const [isConnected, setIsConnected] = useState(false);
    const [accountId, setAccountId] = useState('');
    const handleMessage = event => {
        if (isConnected) {
            return;
        }
        if ((!event.data.taboolaToken && !event.data.token) || !event.data.sessionExp) {
            return;
        }

        authTokenManager.setToken(event.data.taboolaToken || event.data.token, event.data.sessionExp);
        setAccountId(event.data.accountId);
        sessionStorage.setItem('taboola-account-id', event.data.accountId);
        setIsConnected(true);
    };

    useEventListener('message', handleMessage, window);

    useEffect(() => {
        if (isConnected) {
            return;
        }

        setIsConnected(!!authTokenManager.getToken());
        setAccountId(sessionStorage.getItem('taboola-account-id'));
    }, [isConnected, setIsConnected, setAccountId]);

    const value = useMemo(
        () => ({
            isConnected,
            setIsConnected,
            accountId,
        }),
        [isConnected, setIsConnected, accountId]
    );

    if (!isConnected && !isMock) {
        return null;
    }

    return <TaApiContext.Provider value={value}>{children}</TaApiContext.Provider>;
};

export const useTAApi = () => {
    const context = useContext(TaApiContext);
    if (!context) {
        throw new Error('useTAApi must be used within a TAApiProvider');
    }
    return context;
};
